import UserAppContext from '../../hook/UserAppContext'
import Empty from '../empty/Empty'
import './relation.css'

const Relation = ({isRelation}) => {

      if(!isRelation) return

      const {user, data} = UserAppContext()
      const {relation} = user.user

      if(relation.data){
        return (
            <Empty text={"Oops! Not Found"}/>
        )
      }

      const name = relation.name === '' ? data.relation.name : relation.name 
      const avatar = relation.avatar === '' ? data.relation.avatar : relation.avatar 
      const id_xat = relation.id_xat === '' ? data.relation.id_xat : relation.id_xat
      const about = relation.about === '' ? data.relation.about : relation.about
      const me = relation.me === '' ? data.relation.me : relation.me

        return (
            <div className={isRelation ? "page_content show" : "page_content"}>
                    <div className="relation_content">
                        <div className="relation_avatar">
                            <img src={avatar} alt={name} />
                        </div>
                        <div className="relation_data">
                            <h2>{name}</h2>
                            <strong>{id_xat}</strong>
                            <p>{about}</p>
                            <a href={me} target="_blank" rel="noreferrer">xat.me</a>
                        </div>
                    </div>
            </div>
        )
}

export default Relation
